// extracted by mini-css-extract-plugin
export default {"clickArea":"style-module--clickArea--BmrO0","mainContentClass":"style-module--mainContentClass--3nW0O"};